module.exports = __webpack_public_path__ + "img/trailerFrontRight.b984fa03.svg";